import { BaseClass } from '../base/BaseClass';

export class BurgerMenu extends BaseClass {
  /**
   *
   * Holds the menu object in the dom
   * @type {HTML Node}
   *
   */
  menuItems;

  /**
   *
   * Class for opening the burger menu
   * @type {string}
   *
   */
  openingAnimationClass = 'sih-navigation__burger-menu-opening';

  /**
   *
   * Class for closing the burger menu
   * @type {string}
   *
   */
  closingAnimationClass = 'sih-navigation__burger-menu-closing';

  /**
   *
   * Class for opening the burger menu inner menu
   * @type {string}
   *
   */
  menuOpeningAnimationClass = 'menu-open';

  /**
   *
   * Class for closing the burger menu inner menu
   * @type {string}
   *
   */
  menuClosingAnimationClass = 'menu-closed';

  /**
   *
   * Makes sure opening animation isn't shown on page load.
   * @type {bool}
   *
   */
  firstClick = false;

  /**
   * @class
   *
   * @extends {BaseClass}
   *
   * Handles the mobile burger menu opening and closing
   *
   */
  constructor(identifier, multi) {
    super(identifier, multi);
    if (this.targetExists()) {
      this.menuItems = document.querySelector(
        '.sih-navigation__upper-menu-items .sih-navigation__menu-items'
      );
      this.init();
    }
  }

  /**
   * Called to init the class if target element is present.
   */
  init = () => {
    this.target.addEventListener('click', this.handleClick);
  };

  /**
   * Handles the click of the menu button
   */
  handleClick = () => {
    if (this.isMobile) {
      if (!this.firstClick) {
        this.menuItems.classList.add(this.menuOpeningAnimationClass);
        this.target.classList.add(this.openingAnimationClass);
        this.firstClick = true;
      } else {
        this.menuItems.classList.toggle(this.menuClosingAnimationClass);
        this.target.classList.toggle(this.closingAnimationClass);
      }
    }
  };
}
